import React from 'react';
import ContainerComponent from '../../helpers/components/container.component';
import PageHeaderComponent from '../../helpers/components/page_header.component';
import ItemCategoryListTable from './components/item_category_list_table';

const ItemCategoryList = () => {
    return (
        <>
            <ContainerComponent span={22} top={20}>
                <PageHeaderComponent />
                <ItemCategoryListTable />
            </ContainerComponent>
        </>
    );
}

export default ItemCategoryList;